import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'demo-guide-menu',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './demo-guide-menu.component.html',
  styleUrl: './demo-guide-menu.component.scss',
})
export class DemoGuideMenuComponent {
  isExpanded$ = new BehaviorSubject('true');

  components = [
    {
      id: 'section-colors',
      label: 'Colors',
    },
    {
      id: 'section-typography',
      label: 'Typography',
    },
    {
      id: 'section-grid',
      label: 'Grid',
    },
    {
      id: 'section-spacing',
      label: 'Spacing',
    },
    {
      id: 'section-global-messages',
      label: 'Global Messages',
    },
    {
      id: 'section-alerts',
      label: 'Alerts',
    },
    {
      id: 'section-toasters',
      label: 'Toasters',
    },
    {
      id: 'section-buttons',
      label: 'Buttons',
    },
    {
      id: 'section-form-elements',
      label: 'Form Elements',
    },
    {
      id: 'collapse-list',
      label: 'Collapse List',
    },
    {
      id: 'toggle-text',
      label: 'Toggleable Text',
    },
    {
      id: 'section-modal',
      label: 'Modal',
    },
    {
      id: 'section-loaders',
      label: 'Loaders',
    },
    {
      id: 'section-responsive-table',
      label: 'Responsive Table',
    },
    {
      id: 'section-screen-view-directives',
      label: 'Screen View Directives',
    },
  ];

  scrollToSection(sectionId: string) {
    const element = document.getElementById(sectionId);
    element && element.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  toggleMenu() {
    const status = this.isExpanded$.getValue() === 'true' ? 'false' : 'true';
    this.isExpanded$.next(status);
  }
}
